"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpWidgetVXApp = void 0;
const gs = require("@ivanlog/gs");
const tmpls_1 = require("./tmpls");
const BiMath_1 = require("../libs/BiMath");
const ClassesTags_1 = require("../libs/ClassesTags");
const App_1 = require("../App");
const VXInfrastructure_1 = require("../contracts/VXInfrastructure");
class CmpWidgetVXApp extends tmpls_1.CmpWidgetVXAppBase {
    constructor() {
        super();
        this._vxRate = BiMath_1.BiMath.Decimal;
        this._vxAPR = BiMath_1.BiMath.Zero;
        this._vxValidatorGas = BiMath_1.BiMath.Zero;
        this._validatorCost = BiMath_1.BiMath.ToBI("32000000");
        this._pricePLS = BiMath_1.BiMath.Zero;
        this._app = App_1.App.Inst;
        const stakeT0 = this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount0;
        const stakeT1 = this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount1;
        const stakeR = this.ctrls.rStakeRangePLS;
        const unstakeT0 = this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount0;
        const unstakeT1 = this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount1;
        const btnClaimPLS = this.ctrls.btnClaimPLS;
        const btnClaimUPLS = this.ctrls.btnClaimUPLS;
        stakeT0.setToken("PLS");
        stakeT1.setToken("uPLS");
        unstakeT0.setToken("uPLS");
        unstakeT1.setToken("PLS");
        this.ctrls.aAddUPLSToWallet1.onclick =
            this.ctrls.aAddUPLSToWallet2.onclick = (e) => __awaiter(this, void 0, void 0, function* () {
                gs.events.stop(e);
                if (!App_1.App.chain.account)
                    yield App_1.App.chain.getAccountAsync();
                if (App_1.App.chain.account)
                    yield App_1.App.chain.addTokenToWalletAsync(this._vxInf.vx.address, "uPLS", 18);
            });
        this._resetUI();
        this.ctrls.btnConnect.onclick = () => __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnConnect.disable();
            const result = yield App_1.App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        });
        this.ctrls.btnTabStake.onclick = () => this.openTab(this.ctrls.tabStake);
        this.ctrls.btnTabUnstake.onclick = () => this.openTab(this.ctrls.tabUnstake);
        ///*******************Stake*******************
        let cacheStakeGasValue = BiMath_1.BiMath.Zero;
        let cacheStakeValue = BiMath_1.BiMath.Zero;
        let cacheStakeVXValue = BiMath_1.BiMath.Zero;
        const fillStakeFromCache = () => {
            let rangeValue = cacheStakeValue * BiMath_1.BiMath.Decimal / this._plsBalance;
            this.ctrls.rStakeRangePLS.value = parseInt(parseFloat(BiMath_1.BiMath.ToEth(rangeValue)) * 100 + "");
            if (parseFloat(BiMath_1.BiMath.ToEth(cacheStakeValue)) < 1)
                this.ctrls.btnStake.disable();
            else
                this.ctrls.btnStake.enable();
            if (!App_1.App.chain.account)
                this.ctrls.btnStake.disable();
            cacheStakeGasValue = cacheStakeValue * this._vxValidatorGas / this._validatorCost;
            if (cacheStakeGasValue == BiMath_1.BiMath.Zero)
                this.ctrls.lValidatorsGas.text = '';
            else
                this.ctrls.lValidatorsGas.text = "Gas for validators: " + BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(cacheStakeGasValue), 3);
            const price = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(this._pricePLS * cacheStakeValue / BiMath_1.BiMath.Decimal), 2) + "$";
            stakeT0.ctrls.lSubText.text =
                stakeT1.ctrls.lSubText.text = price;
        };
        stakeR.onChangeValue.addHandler((balancePercent) => {
            cacheStakeValue = this._plsBalance * BiMath_1.BiMath.ToBIFromNumber(balancePercent / 100 * 0.99) / BiMath_1.BiMath.Decimal;
            cacheStakeVXValue = cacheStakeValue * BiMath_1.BiMath.Decimal / this._vxRate;
            stakeT0.setValueBI(cacheStakeValue);
            stakeT1.setValueBI(cacheStakeVXValue);
            fillStakeFromCache();
        });
        stakeT0.onChangeValue.addHandler((valuePLS) => {
            cacheStakeValue = valuePLS;
            cacheStakeVXValue = cacheStakeValue * BiMath_1.BiMath.Decimal / this._vxRate;
            stakeT1.setValueBI(cacheStakeVXValue);
            fillStakeFromCache();
        });
        stakeT1.onChangeValue.addHandler((valueUPLS) => {
            cacheStakeVXValue = valueUPLS;
            cacheStakeValue = cacheStakeVXValue * this._vxRate / BiMath_1.BiMath.Decimal;
            stakeT0.setValueBI(cacheStakeValue);
            fillStakeFromCache();
        });
        this.ctrls.btnStake.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vx.stakeAsync(BiMath_1.BiMath.ToEth(cacheStakeValue + cacheStakeGasValue), false));
            if (result) {
                this._successFunc();
                yield this.refreshAsync();
            }
        });
        ///*******************Unstake*******************
        {
            let cacheUnstakeVXValue = BiMath_1.BiMath.Zero;
            let cacheUnstakeValue = BiMath_1.BiMath.Zero;
            const fillUnstakeFromCache = () => {
                if (parseFloat(BiMath_1.BiMath.ToEth(cacheUnstakeVXValue)) < 0.001)
                    this.ctrls.btnUnstake.disable();
                else
                    this.ctrls.btnUnstake.enable();
                if (!App_1.App.chain.account)
                    this.ctrls.btnUnstake.disable();
                const price = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(this._pricePLS * cacheUnstakeValue / BiMath_1.BiMath.Decimal), 2) + "$";
                unstakeT0.ctrls.lSubText.text =
                    unstakeT1.ctrls.lSubText.text = price;
            };
            unstakeT0.onChangeValue.addHandler((valueUPLS) => {
                cacheUnstakeVXValue = valueUPLS;
                if (cacheUnstakeVXValue > this._vxBalance) {
                    cacheUnstakeVXValue = this._vxBalance;
                    unstakeT0.ctrls.iValue.value = BiMath_1.BiMath.ToEth(cacheUnstakeVXValue);
                }
                cacheUnstakeValue = cacheUnstakeVXValue * this._vxRate / BiMath_1.BiMath.Decimal;
                unstakeT1.setValueBI(cacheUnstakeValue);
                fillUnstakeFromCache();
            });
            unstakeT1.onChangeValue.addHandler((valuePLS) => {
                cacheUnstakeValue = valuePLS;
                cacheUnstakeVXValue = cacheUnstakeValue * BiMath_1.BiMath.Decimal / this._vxRate;
                if (cacheUnstakeVXValue > this._vxBalance) {
                    cacheUnstakeVXValue = this._vxBalance;
                    cacheUnstakeValue = cacheUnstakeVXValue * this._vxRate / BiMath_1.BiMath.Decimal;
                    unstakeT1.setValueBI(cacheUnstakeValue);
                }
                unstakeT0.setValueBI(cacheUnstakeVXValue);
                fillUnstakeFromCache();
            });
            this.ctrls.btnUnstake.onclick = () => __awaiter(this, void 0, void 0, function* () {
                const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vx.unstakeAsync(BiMath_1.BiMath.ToEth(cacheUnstakeVXValue), false));
                if (result) {
                    this._successFunc();
                    yield this.refreshAsync();
                }
            });
        }
    }
    get vxAPR() { return this._vxAPR; }
    setStatusCmp(status) {
        this._status = status;
    }
    refreshAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const vxInf = App_1.App.Inst.getInst(VXInfrastructure_1.VXInfrastructure);
            this._vxInf = vxInf;
            const ctrls = this.ctrls;
            ctrls.rStakeRangePLS.hide();
            const account = App_1.App.chain.account;
            const vxData = yield vxInf.vcontroller.getVXRateAsync();
            this._resetUI();
            this._vxAPR = BiMath_1.BiMath.ToBI(vxData.apr);
            this._vxRate = BiMath_1.BiMath.ToBI(vxData.vxRatio);
            if (this._status)
                yield this._status.refreshAsync(vxData, vxInf.vx, vxInf.vpool, vxInf.vcontroller, App_1.App.chain.account);
            this._vxBalance = this._status.vxBalance;
            const vxValidatorGas = yield vxInf.vcontroller.getValidatorGas();
            this._vxValidatorGas = BiMath_1.BiMath.ToBI(vxValidatorGas);
            const pricePLS = yield vxInf.priceKeeperPLS.getPrice();
            this._pricePLS = BiMath_1.BiMath.ToBI(pricePLS);
            if (account) {
                const plsBalance = yield App_1.App.chain.getBalanceEth();
                this._plsBalance = BiMath_1.BiMath.ToBI(plsBalance);
                ctrls.rStakeRangePLS.show();
                ctrls.btnConnect.hide();
                ctrls.btnStake.show();
                ctrls.btnTabUnstake.enable();
                const withdrawalPLS = yield vxInf.vx.getWithdrawalAsync(account);
                this._withdrawalPLS = BiMath_1.BiMath.ToBI(withdrawalPLS);
                let needShowClaimBtns = false;
                if (this._withdrawalPLS > 0) {
                    needShowClaimBtns = true;
                    const btnClaimPLS = this.ctrls.btnClaimPLS;
                    let exist = this._status.vxInstWithdrawal;
                    if (exist >= this._withdrawalPLS) {
                        exist = this._withdrawalPLS;
                        btnClaimPLS.ctrls.btn.html = `Claim ${BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(exist), 3)} PLS`;
                    }
                    else {
                        btnClaimPLS.ctrls.btn.html = `Claim ${BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(exist), 3)} PLS`;
                        btnClaimPLS.ctrls.lTag.text = BiMath_1.BiMath.ToEth(this._withdrawalPLS) + " PLS";
                        btnClaimPLS.ctrls.lTag.show();
                    }
                    if (exist == BiMath_1.BiMath.Zero)
                        btnClaimPLS.disable();
                    else {
                        btnClaimPLS.enable();
                        btnClaimPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
                            const result = yield App_1.App.gui.awaitInLockUIAsync(vxInf.vx.withdraw(BiMath_1.BiMath.ToEth(exist), App_1.App.chain.account));
                            if (result) {
                                this._successFunc();
                                yield this.refreshAsync();
                            }
                        });
                    }
                }
                const withdrawalUPLS = yield vxInf.vx.getReserveOfAsync(account);
                this._withdrawalUPLS = BiMath_1.BiMath.ToBI(withdrawalUPLS.value);
                if (this._withdrawalUPLS > 0) {
                    needShowClaimBtns = true;
                    this.ctrls.btnClaimUPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
                        const result = yield App_1.App.gui.awaitInLockUIAsync(vxInf.vx.withdrawReserveAsync());
                        if (result) {
                            this._successFunc();
                            yield this.refreshAsync();
                        }
                    });
                    const cooldownDelta = parseInt(withdrawalUPLS.cooldownUntil) - Date.now() / 1000;
                    this.ctrls.btnClaimUPLS.enable();
                    this.ctrls.btnClaimUPLS.ctrls.btn.html = `Claim ${BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(this._withdrawalUPLS), 3)} uPLS`;
                    this.ctrls.btnClaimUPLS.ctrls.lTag.hide();
                    if (cooldownDelta > 0) {
                        this.ctrls.btnClaimUPLS.disable();
                        this.ctrls.btnClaimUPLS.ctrls.lTag.text = "cooldown " + (parseInt(cooldownDelta / 60 + "") + 1) + " mins";
                        this.ctrls.btnClaimUPLS.ctrls.lTag.show();
                    }
                }
                ctrls.blockBtnsClaim.showSet(needShowClaimBtns);
            }
            else {
                ctrls.btnConnect.show();
                ctrls.btnStake.hide();
                ctrls.btnTabUnstake.disable();
                this.openTab(ctrls.tabStake);
            }
        });
    }
    openTab(tab) {
        const ctrls = this.ctrls;
        if (ctrls.tabStake == tab) {
            ctrls.tabStake.show();
            ctrls.tabUnstake.hide();
            ctrls.btnTabStake.addClass(ClassesTags_1.ClassesTags.Active);
            ctrls.btnTabUnstake.removeClass(ClassesTags_1.ClassesTags.Active);
        }
        else {
            ctrls.tabStake.hide();
            ctrls.tabUnstake.show();
            ctrls.btnTabStake.removeClass(ClassesTags_1.ClassesTags.Active);
            ctrls.btnTabUnstake.addClass(ClassesTags_1.ClassesTags.Active);
        }
    }
    _successFunc() { App_1.App.gui.dialogOkShowAsync("The transaction was completed successfully.", "Information"); }
    _resetUI() {
        const stakeT0 = this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount0;
        const stakeT1 = this.ctrls.cmpStakeTokens.ctrls.cmpInputTokenAmount1;
        const unstakeT0 = this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount0;
        const unstakeT1 = this.ctrls.cmpUnstakeTokens.ctrls.cmpInputTokenAmount1;
        const btnClaimPLS = this.ctrls.btnClaimPLS;
        const btnClaimUPLS = this.ctrls.btnClaimUPLS;
        btnClaimPLS.ctrls.btn.text = "Claim PLS";
        btnClaimPLS.ctrls.lTag.hide();
        btnClaimPLS.disable();
        btnClaimUPLS.ctrls.btn.text = "Claim uPLS";
        btnClaimUPLS.ctrls.lTag.hide();
        btnClaimUPLS.disable();
        this.ctrls.blockBtnsClaim.hide();
        this.ctrls.lValidatorsGas.text = "";
        stakeT0.ctrls.lSubText.text =
            stakeT1.ctrls.lSubText.text =
                unstakeT0.ctrls.lSubText.text =
                    unstakeT1.ctrls.lSubText.text = '';
        this.ctrls.btnStake.hide();
        stakeT0.ctrls.iValue.value =
            stakeT1.ctrls.iValue.value =
                unstakeT0.ctrls.iValue.value =
                    unstakeT1.ctrls.iValue.value = '';
    }
}
exports.CmpWidgetVXApp = CmpWidgetVXApp;
//# sourceMappingURL=CmpWidgetVXApp.js.map